module.exports = __webpack_public_path__ + "img/tpc-32.69fa2bf9.webp";